import React from 'react'
import AboutIntroSection from '../components/__SeasonTwo__/__Pages__/About/AboutIntroSection'
import AboutSeasonOneSection from '../components/__SeasonTwo__/__Pages__/About/AboutSeasonOneSection'
import AboutSeasonTwoSection from '../components/__SeasonTwo__/__Pages__/About/AboutSeasonTwoSection'
import AboutLandingSection from '../components/__SeasonTwo__/__Pages__/About/AboutLandingSection'
import AboutEndingSection from '../components/__SeasonTwo__/__Pages__/About/AboutEndingSection'
import { Meta } from '../components/Meta'


const About = ({data}) => {
    data = data.allContentfulSiteGlobalData.edges[0].node;

    return (
        <div>
            <Meta title="About" />
            <AboutLandingSection data={data}/>
            <AboutIntroSection data={data}/>
            <AboutSeasonOneSection data={data}/>
            <AboutSeasonTwoSection data={data}/>
            <AboutEndingSection data={data}/>
        </div>
    )
}

export default About


export const pageQuery = graphql`
  query AboutV2Query {
    allContentfulSiteGlobalData(filter: { node_locale: { eq: "en-US" } }) {
      edges {
        node {
            v2IntroText {
                v2IntroText
              }

          v2AboutIntro {
            v2AboutIntro
          }

          v2AboutSeason1Heading

          v2AboutSeason1 {
            v2AboutSeason1
          }

          v2AboutSeason2Heading 

          v2AboutSeason2 {
            v2AboutSeason2
          }

          v2AboutImages {
            file {
              url
            }
          }
        }
      }
    }

  }
`
